// extracted by mini-css-extract-plugin
module.exports = {"pintxo-coachmark":"Coachmark_pintxo-coachmark__VKE3X"};